import { createAsyncThunk } from '@reduxjs/toolkit'
import { getIDToken } from '../utils/AuthUtil'
import { RootState } from '../store'
import { BASE_URL } from '../config'
import { AssignItem } from '../models/Review'
import {
  assignItem,
  setAssignedItems,
  setAssignedProjects,
  setEngineerOrganization,
  updateAssignedProject,
} from '../actions/review'

export const fetchReviewStatus = createAsyncThunk(
  'review/fetchStatus',
  async (
    payload: { organization_id: number; file_id: number },
    { dispatch, getState },
  ) => {
    return fetch(`${BASE_URL}/api/review/fetchStatus`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok)
          return response.json().then((response) => {
            throw new Error(response.error)
          })
        return response.json()
      })
      .then((data) => {
        dispatch(setAssignedItems(data))
      })
  },
)

export const fetchAdminAssignedProjects = createAsyncThunk(
  'review/fetchAdminProjects',
  async (payload: { organization_id: number }, { dispatch, getState }) => {
    return fetch(`${BASE_URL}/api/review/fetchAdminProjects`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok)
          return response.json().then((response) => {
            throw new Error(response.error)
          })
        return response.json()
      })
      .then((data) => {
        dispatch(setAssignedProjects(data))
      })
  },
)

export const fetchEngineerAssignedProjects = createAsyncThunk(
  'review/fetchAdminProjects',
  async (
    payload: { organization_id: number; user_id: number },
    { dispatch, getState },
  ) => {
    return fetch(`${BASE_URL}/api/review/fetchEngineerProjects`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok)
          return response.json().then((response) => {
            throw new Error(response.error)
          })
        return response.json()
      })
      .then((data) => {
        dispatch(setAssignedProjects(data))
      })
  },
)

export const assignProjectToOrganization = createAsyncThunk(
  'review/assignProject',
  async (project: AssignItem, { dispatch, getState }) => {
    return fetch(`${BASE_URL}/api/review/assignProject`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(project),
    })
      .then((response) => {
        if (!response.ok)
          return response.json().then((response) => {
            throw new Error(response.error)
          })
        return response.json()
      })
      .then((data) => {
        dispatch(assignItem(data))
      })
  },
)

export const assignEngineerToProject = createAsyncThunk(
  'review/assignEngineerToProject',
  async (project: AssignItem, { dispatch, getState }) => {
    return fetch(`${BASE_URL}/api/review/assignEngineer`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(project),
    })
      .then((response) => {
        if (!response.ok)
          return response.json().then((response) => {
            throw new Error(response.error)
          })
        return response.json()
      })
      .then((data) => {
        dispatch(updateAssignedProject(data))
      })
  },
)

export const updateAssignedProjectAsync = createAsyncThunk(
  'review/updateAssignedProject',
  async (project: AssignItem, { dispatch, getState }) => {
    return fetch(`${BASE_URL}/api/review/updateAssignedProject`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        discipline: project.discipline,
        discipline_status: project.discipline_status,
        organization_id: project.organization_id,
        file_id: project.file_id,
        user_id: project.user_id,
      }),
    })
      .then((response) => {
        if (!response.ok)
          return response.json().then((response) => {
            throw new Error(response.error)
          })
        return response.json()
      })
      .then((data) => {
        dispatch(updateAssignedProject(data))
      })
  },
)

export const fetchEngineerOrganizationAsync = createAsyncThunk(
  'review/fetchEngineerOrganization',
  async (_, { dispatch }) => {
    return fetch(`${BASE_URL}/api/organizations/findByName`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name: 'Engineer' }),
    })
      .then((response) => {
        if (!response.ok)
          return response.json().then((response) => {
            throw new Error(response.error)
          })
        return response.json()
      })
      .then((data) => {
        dispatch(setEngineerOrganization(data))
      })
  },
)
